import { useEffect, useRef, useState } from "react";

export const useDownload = () => {
    const [_, setInit] = useState(false);
    const ref = useRef<(data: any, filename: string) => void>(undefined);

    useEffect(() => {
        if (document) {
            ref.current = (data: Blob | string, filename: string) => {
                const url = data instanceof Blob ? URL.createObjectURL(data) : data;
                const link = document.createElement("a");
                link.href = url;
                link.download = filename;
                link.click();
                link.remove();
                data instanceof Blob && URL.revokeObjectURL(url);
            };
            setInit(true);
        }
    }, []);

    return ref.current;
};
